import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { UpdatePaymentApiTradesPostRequestModel, UpdatePaymentApiTradesPostResponseModel } from "@/features/accounts/payment/api/services/update-trades-model";

export class UpdatePaymentApiTradesApi {
  /**
   * MoneyLook明細更新（API版）API
   */
  public updatePaymentApiTrades = async (
    param: UpdatePaymentApiTradesPostRequestModel
  ): Promise<UpdatePaymentApiTradesPostResponseModel> => {
    const path = `/api/paymentaccounts/api/aggregate`;
    const res = await ApiClient.instance.post<UpdatePaymentApiTradesPostResponseModel>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
